export default __webpack_public_path__ + "static/media/pets.6d382ecc.png";